import { render, staticRenderFns } from "./profitList.vue?vue&type=template&id=643769b6"
import script from "./profitList.vue?vue&type=script&lang=js"
export * from "./profitList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports